<div [avanoLoadingIndicator]="blockingIdentifier">
  <avano-table
    *ngIf="tableConfigurationInitialized"
    [tableRef]="productsTable"
    [tableConfiguration]="tableConfiguration"
    [headerText]="translationKeys.productsTableComponent.typescript.buttonBarHeaderText | translate"
    (export)="showExportDialog()"
    (refresh)="refreshTable()"
  >
    <p-table
      #productsTable
      [columns]="columnConfig"
      [value]="products"
      [filters]="filters"
      dataKey="id"
      (onRowUnselect)="rowsChanged()"
      (onRowSelect)="rowsChanged()"
      [(selection)]="selectedProducts"
      (selectionChange)="rowsChanged()"
      [(rows)]="rowsCount"
      [lazy]="true"
      (onLazyLoad)="lazyLoad($event)"
      [totalRecords]="totalProductsCount"
      [first]="firstOffSet"
      [scrollable]="true"
      columnResizeMode="expand"
      scrollDirection="both"
      scrollHeight="calc(100vh - 260px)"
      responsiveLayout="scroll"
      [resizableColumns]="true"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="flex: 0 0 3rem" pFrozenColumn>
            <avano-tableHeaderCheckbox></avano-tableHeaderCheckbox>
          </th>
          <th *ngFor="let col of columns; let i = index" [avanoTableColumnHeader]="col" [isLastSortable]="i === columns.length - 1">
            <scip-table-filter
              style="flex-grow: 1"
              [style.visibility]="col.filterable !== true ? 'hidden' : 'visible'"
              (userInput)="triggerColumnFilter(col, $event)"
              [restoredValue]="productsTable.filters[col.field] | valueFromFiltermetadata"
              [filterConfiguration]="col.filterConfiguration"
              parentTableIdentifier="productsTableIdentifier"
            ></scip-table-filter>
          </th>
          <th class="avano-table-header-filterreset-placeholder last-resizable" pFrozenColumn alignFrozen="right">
            <scip-table-filter-reset-all parentTableIdentifier="productsTableIdentifier" (filterReset)="resetFilters()"></scip-table-filter-reset-all>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <div class="emptyInfo">{{ emptyMessage | translate }}</div>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData" [pSelectableRowDisabled]="true">
          <td style="flex: 0 0 3rem" pFrozenColumn>
            <p-tableCheckbox [value]="rowData" style="margin: -3px 0 0 0"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let col of columns; let i = index">
            <td [ngSwitch]="col.field" [avanoTableCell]="col" [isLastSortable]="i === columns.length - 1">
              <div *ngSwitchCase="columnKeys.articleCategories" avanoEllipsis>
                {{ rowData[col.field] | articleCategoryList }}
              </div>

              <div
                *ngSwitchCase="columnKeys.scipDossierSubmissionStatus"
                avanoEllipsis
                [setTitle]="false"
                [scipSubmissionStatus]="rowData[columnKeys.scipDossierSubmissionStatus]"
              >
                <span [pTooltip]="rowData[columnKeys.scipDossierSubmissionStatus] | dossierStateTranslationKey: true | translate">
                  {{ rowData[columnKeys.scipDossierSubmissionStatus] | dossierStateTranslationKey | translate }}
                </span>
              </div>

              <div *ngSwitchCase="columnKeys.productionInEU" avanoEllipsis>
                {{ rowData[columnKeys.productionInEU] | productionInEUTranslationKey | translate }}
              </div>

              <div *ngSwitchCase="columnKeys.updatedAt" avanoEllipsis>
                {{ rowData[columnKeys.updatedAt] | date: 'medium' }}
              </div>

              <div *ngSwitchCase="columnKeys.submissionDate" avanoEllipsis>
                {{ rowData[columnKeys.submissionDate] | date: 'medium' }}
              </div>

              <div *ngSwitchCase="columnKeys.scipRelevantChanged" avanoEllipsis>
                {{ rowData[columnKeys.scipRelevantChanged] | date: 'medium' }}
              </div>

              <div *ngSwitchCase="columnKeys.euMarketRelevantChanged" avanoEllipsis>
                {{ rowData[columnKeys.euMarketRelevantChanged] | date: 'medium' }}
              </div>

              <div *ngSwitchCase="columnKeys.info" avanoEllipsis>
                <i
                  *ngIf="rowData[columnKeys.lockedForUpdate] === true"
                  class="icon-content-info avano-tooltip-icon"
                  [pTooltip]="translationKeys.productsTableComponent.html.productInformationLoading | translate"
                  tooltipPosition="left"
                  style="font-size: 1rem"
                ></i>
                <i
                  *ngIf="rowData[columnKeys.downloadError] === true"
                  class="icon-content-info"
                  [pTooltip]="rowData[columnKeys.errorMessage]"
                  tooltipPosition="left"
                  style="font-size: 1rem; color: #b2492f"
                ></i>
                <i
                  *ngIf="rowData[columnKeys.echaResponseStatus] !== submissionStatus.DOSSIER_SENT_TO_ECHA && rowData[columnKeys.echaResponseStatus]"
                  class="icon-content-error dossier-error-dialog-icon"
                  style="font-size: 1rem; color: #cc0000"
                  (click)="showErrorDetails(rowData)"
                >
                </i>
              </div>

              <div *ngSwitchCase="columnKeys.otherArticleIdentifiers" avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
                <span *ngFor="let identifier of rowData[columnKeys.otherArticleIdentifiers] | otherArticleIdentifier; let last = last">
                  {{ identifier.textKey | translate }}:{{ identifier.value }}<ng-container *ngIf="!last">,</ng-container>
                </span>
              </div>

              <div *ngSwitchCase="columnKeys.orgVerificationstatus" avanoEllipsis>
                <i
                  *ngIf="rowData[columnKeys.orgVerificationstatus] === true && rowData[columnKeys.validationErrors] == null"
                  class="icon-content-success dossier-error-dialog-icon"
                  style="font-size: 1rem; color: #008800"
                ></i>
                <i
                  *ngIf="rowData[columnKeys.orgVerificationstatus] === true && rowData['validationErrors']"
                  class="icon-content-error dossier-error-dialog-icon"
                  style="font-size: 1rem; color: #cc0000"
                  (click)="showOrgErrorDetails(rowData)"
                ></i>
              </div>

              <ng-container *ngSwitchCase="columnKeys.name">
                <ng-container *ngTemplateOutlet="spacesAsIs"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="columnKeys.number">
                <ng-container *ngTemplateOutlet="spacesAsIs"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="columnKeys.organizationName">
                <ng-container *ngTemplateOutlet="spacesAsIs"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="columnKeys.orgGroupName">
                <ng-container *ngTemplateOutlet="spacesAsIs"></ng-container>
              </ng-container>

              <div *ngSwitchDefault avanoEllipsis>
                {{ rowData[col.field] }}
              </div>
              <ng-template #spacesAsIs>
                <div avanoEllipsis [useNoWrap]="false" scipSpacesAsIs>
                  {{ rowData[col.field] }}
                </div>
              </ng-template>
            </td>
          </ng-container>
          <td class="avano-table-header-filterreset-placeholder" pFrozenColumn alignFrozen="right">
            <!-- Needed as placeholder because of "table"-behavior -->
          </td>
        </tr>
      </ng-template>
    </p-table>
  </avano-table>
</div>

<scip-dossier-error-details-dialog
  *ngIf="showDossierErrorDetails"
  [dossierError]="selectedDossierError"
  (closeDialog)="showDossierErrorDetails = false"
></scip-dossier-error-details-dialog>

<scip-dossier-error-details-dialog
  *ngIf="showOrganizationErrorDetails"
  [header]="translationKeys.organizationTableComponent.html.organizationErrorDialogTitle | translate"
  [dossierError]="selectedOrgError"
  (closeDialog)="showOrganizationErrorDetails = false"
></scip-dossier-error-details-dialog>

<scip-download-dialog *ngIf="displayExportDialog" (downloadEvent)="downloadReport($event)" (cancelEvent)="closeDownloadDialog()"></scip-download-dialog>
